import styled from "@emotion/styled";

export const CheckoutOrderSummaryWrapper = styled.section`
  width: 100%;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 100vw;
    margin-inline: calc(var(--ot-gutter) * -1);
  }

  .free-shipping {
    font-size: ${({ theme }) => theme.fontSizes.fontSize14};
    font-weight: 600;
    font-style: normal;
    text-transform: uppercase;
    color: ${({ theme }) => theme.colors.semantic.green};
  }
`;

export const PaymentMethodsWrapper = styled.div`
  padding: ${({ theme }) => theme.space.space16};

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: ${({ theme }) => theme.space.space32} 0;
  }
`;
